export default function ownerDocument(element) {
    return element.ownerDocument || element.document || element;
}



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-popup-common/dist/es/owner-document.js
// module id = ../../../../@progress/kendo-popup-common/dist/es/owner-document.js
// module chunks = 3